function InvitationCtrl($scope, $state, $stateParams, toaster, InvitationService) {
  'ngInject'
  const vm = this;
  vm.passwordForm = {};
  vm.invite_token = $stateParams.invitation_token;

  vm.acceptInvitation = function() {
    vm.submitted = true;
    InvitationService.setPassword(vm.invite_token, vm.passwordForm, function(response){
      if (response.data.errors) {
        toaster.pop('error', response.data.errors[0]);
      }
      else if (response.data.success){
        toaster.pop('info', 'Password updated successfully.');
        $state.go('login', {inherit: false});
      }
      vm.passwordForm = {};
      $scope.pwdForm.$setPristine();
      $scope.pwdForm.$setUntouched();
    });
  };
};

export default {
  name: 'InvitationCtrl',
  fn: InvitationCtrl
};
